
//マップ
// google-map
function initMap() {

  // 地図の初期中心座標を指定
  var latLng = new google.maps.LatLng(35.6465853,135.8835024);

  var map = new google.maps.Map(
    document.getElementById("gmap"), {
      zoom: 9, // 地図の初期拡大率
      center: latLng, // 先ほど設定した中心座標を設定
      scrollwheel: false // マウスホイールで拡縮しなくなる
    }
  );
  // マーカーの設定
  var markerImg = {
    url: '/_assets/imgs/map_icon.png' // マーカーの画像ファイルを指定
  };
  var marker = new google.maps.Marker({
    position: {
      lat: 35.512439,
      lng: 135.880579
    },
    map: map
    // ,
    // icon: markerImg
  });


  var styles = {
    wakasa: [


      {
        featureType: 'administrative',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'administrative.province',
        stylers: [{
          visibility: 'on'
        }]
      },
      {
        featureType: 'administrative.locality',
        stylers: [{
          visibility: 'on'
        }]
      },
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      },
    {
        featureType: 'poi',
        stylers: [{
          visibility: 'off'
        }]
      },
      // {
      //   featureType: 'poi.attraction',
      //   stylers: [{visibility: 'on'}]
      // },
      {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'on'
        }]
      }
    ]
  };

    map.setOptions({
      styles: styles['wakasa']
    });
}
